<div class="widget-container" (click)="handleClick()">
  <div class="title-wrapper">
    <div class="title data-xxs">{{ texts.graph_title }}</div>

    @if (!isLaptopScreen()) {
      <div class="hosts-wrapper">
        <span
        class="count data-s-medium">{{ Utils.humanizeNumber(languageService.texts.general.not_available, count()) }}</span>
        <span class="hosts-title data-xxs">{{ texts.hosts_title }}</span>
      </div>
    }

  </div>
  <div class="chart" [class.g-loader-s]="loading()">
    @if (options) {
      <ag-charts-angular [options]="options"></ag-charts-angular>
    }
  </div>
</div>

